export default {
    letSignYouIn: `Let's Sign You In`,
    pleaseProvideYourUsernameAndPassword: 'Please provide your username and password',
    username: 'Username',
    password: 'Password',
    login: 'Login',
    // Sign Up
    resendInSeconds: `Resend in {{no}} seconds`,

    createAccount: 'Create Account',
    letSignYouUp: 'Let Sign You Up',
    pleaseProvideYourFirstnameAndLastnameForSigningUp: 'Please provide your firstname and lastname for Signing Up',
    gender: 'Gender',
    contactNo: 'Contact No',
    sendCode: 'Send Code',
    signUp: 'Sign Up',
    accountLogin: 'Account Login',

    newUserSignUpHere: 'Sign Up',
    forgotPassword: 'Forgot Password?',
    clickHere: 'Click Here',

    resetPassword: 'Reset Password',
    newPassword: 'New Password',
    pleaseEnterYourNewPasswordBelow: 'Please enter your new password below.',

    verifyCode: 'Verify Code',
    enterReceiveVerificationCodeBelow: 'Enter receive verification code below',
    submit: 'Submit',

    verifyExistingUser: 'Verify Existing User',
    pleaseEnterYourContactToVerifyExistingUser: 'Please enter your contact to verify existing user',
};